import { render, staticRenderFns } from "./PageSecondary.vue?vue&type=template&id=71b25bce&scoped=true"
import script from "./PageSecondary.vue?vue&type=script&lang=js"
export * from "./PageSecondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b25bce",
  null
  
)

export default component.exports